import { configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import pageReducer from './page-reducer';
import usersReducer from './users-reducer';
import bannerReducer from './banners-reducer';
import popupReducer from './popup-reducer';
import communicationReducer from "./communication-reducer";
import { timetableMiddleware } from './timetable/timetable.middleware'
import profileReducer from './profile.reducer';
import staticDataReducer from './staticData';
import courseEditorReducer from './courseEditor-reducer';
//import groupEditorReducer from "./groupEditor-reducer";

import profileUserReducer from './profileUser.reducer';
import myGroupsReducer from './children/myGroups.reducer';
import seminarianReducer from './seminarian/seminarian.reducer';
import childrenReducer from './children/children.reducer';
import alertsReducer from './alerts.reducer';
import commonReducer from './common/common.reducer';
import downloadExcelReducer from "./excel.reducer";
import menuReducer from "./menu.reducer";
import confirmReducer from "./confirm-reducer";
import lessonPreviewReduser from "./lessonPreview-reduser"
import languagesReduser from "./languages-reduser";
import settingsReducer from "./settings-reducer";
import surveysReducer from "../components/pages/MySurveys/surveysSlice";
import modalsSlice from "./modalsSlise";
import allRolesSlice from "./allRolesSlise";
import parentSelectedChildIdReducer from "./parent/parentSelectedChildIdSlice";
import parentSelectedChildReducer from "./parent/parentSelectedChildSlice";
import timetableReducer from "./timetable/timetableSlice";
import journalReducer from "./journal.reducer";
import preloaderSlice from "./preloaderSlice";

let reducers = {
	page: pageReducer,
	users: usersReducer,
	banners: bannerReducer,
	communication: communicationReducer,
	popup: popupReducer,

	profile: profileReducer,
	profileUser: profileUserReducer,
	courseEditor: courseEditorReducer,
	//groupEditor: groupEditorReducer,
	staticData: staticDataReducer,
	myGroups: myGroupsReducer,
	seminarianR: seminarianReducer,
	childrenR: childrenReducer,
	alerts: alertsReducer,
	common: commonReducer,
	excel: downloadExcelReducer,
	menu: menuReducer,
	confirm: confirmReducer,
	lessonPreview: lessonPreviewReduser,
	languages: languagesReduser,
	settings: settingsReducer,
	surveys: surveysReducer,
	modals: modalsSlice,
	allRoles: allRolesSlice,
	parentSelectedChildId: parentSelectedChildIdReducer,
	parentSelectedChild: parentSelectedChildReducer,
	timetable: timetableReducer,
	journal: journalReducer,
	preloader: preloaderSlice,
};

const store = configureStore({
	reducer: reducers,
	devTools: process.env.NODE_ENV != 'production',
	middleware: (getDefaultMiddleware) => [thunkMiddleware, timetableMiddleware]
})

store.subscribe(() => (document.title = store.getState().page.titlePage));

export default store;